import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { useParams } from "react-router-dom";
import contactImg from "../assest/images/contact-us/cloud.webp";
import { useLocation } from "react-router-dom";

function Popular() {
  const { slug } = useParams();
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  const pages = {
    "ladakh-tour-packages-from-ahmedabad": {
      title: "Ladakh Tour Packages from Ahmedabad",
      content: (
        <>
          <title>Ladakh Tour Packages from Ahmedabad | Ladakh MotoDrive</title>
          <meta
            name="description"
            content="Book Ladakh tour packages from Ahmedabad with Ladakh MotoDrive. Bike, car & premium tours with expert support. Plan your trip today!"
          />
          <link
            rel="canonical"
            href="https://ladakhmotodrive.com/popular/ladakh-tour-packages-from-ahmedabad"
          />
          <div className="popular-container">
            {/* <h1 className="page-title">Ladakh Tour Packages from Ahmedabad</h1> */}

            <p className="intro">
              Planning a Ladakh trip from Ahmedabad? Ladakh MotoDrive brings you
              the best Ladakh tour packages designed for adventure seekers,
              families, couples, and groups.
            </p>

            <section className="section">
              <h2>Travel from Ahmedabad to Ladakh Made Easy</h2>
              <p>
                Traveling from Ahmedabad to Ladakh is simple and convenient. The
                fastest way is by flight, while budget travelers can opt for
                train or road combinations.
              </p>
            </section>

            <section className="section">
              <h2>Our Ladakh Tour Packages</h2>

              <div className="card">
                <h3>Bike Tour Packages</h3>
                <p>
                  Experience thrilling rides through high mountain passes with
                  full support.
                </p>
              </div>

              <div className="card">
                <h3>Car Tour Packages</h3>
                <p>
                  Comfortable journeys for families and couples with expert
                  drivers.
                </p>
              </div>

              <div className="card">
                <h3>Premium Tour Packages</h3>
                <p>
                  Luxury stays, private vehicles, and personalized itineraries.
                </p>
              </div>
            </section>

            <section className="section">
              <h2>Top Places Covered</h2>
              <ul className="list">
                <li>Leh City</li>
                <li>Nubra Valley</li>
                <li>Pangong Lake</li>
                <li>Tso Moriri</li>
                <li>Magnetic Hill</li>
                <li>Khardung La Pass</li>
              </ul>
            </section>

            <section className="section highlight">
              <h2>Best Time to Visit</h2>
              <p>May to September is the best time to visit Ladakh.</p>
            </section>

            <section className="section">
              <h2>Why Choose Ladakh MotoDrive?</h2>
              <ul className="list tick">
                <li>Trusted local operator</li>
                <li>Budget-friendly packages</li>
                <li>24/7 support</li>
                <li>Experienced guides</li>
                <li>Quality hotels</li>
              </ul>
            </section>

            <section className="section cta">
              <h2>Book Your Ladakh Tour Today!</h2>
              <p>
                Make your dream Ladakh trip from Ahmedabad a reality. Adventure,
                peace, or luxury—we’ve got you covered.
              </p>
            </section>
          </div>
        </>
      ),
    },

    "ladakh-tour-packages-from-hyderabad": {
      title: "Ladakh Tour Packages from Hyderabad",
      content: (
        <>
          <title>Ladakh Tour Packages from Hyderabad | Ladakh MotoDrive</title>
          <meta
            name="description"
            content="Book Ladakh tour packages from Hyderabad with Ladakh MotoDrive. Bike, car & premium tours with expert guides. Customize your dream trip today!"
          />
          <link
            rel="canonical"
            href="https://ladakhmotodrive.com/popular/ladakh-tour-packages-from-hyderabad"
          />
          <div className="popular-container">
            {/* <h1 className="page-title">Ladakh Tour Packages from Hyderabad</h1> */}

            <p className="intro">
              Planning an unforgettable trip from Hyderabad to Ladakh? Ladakh
              MotoDrive offers perfectly curated Ladakh tour packages designed
              for adventure lovers, couples, families, and groups. From
              thrilling bike expeditions to comfortable car tours and premium
              experiences, we ensure a seamless journey from start to finish.
            </p>

            <section className="section">
              <h2>Travel from Hyderabad to Ladakh Made Easy</h2>
              <p>
                Traveling from Hyderabad to Ladakh is now easier than ever. Most
                travelers prefer flights from Hyderabad to Leh for convenience,
                while some choose train + road combinations for a more
                budget-friendly option.
              </p>
              <p>
                At Ladakh MotoDrive, we help you plan everything—from arrival in
                Leh to your complete Ladakh exploration—so you can enjoy your
                trip stress-free.
              </p>
            </section>

            <section className="section">
              <h2>Our Ladakh Tour Packages from Hyderabad</h2>

              <div className="card">
                <h3>Bike Tour Packages</h3>
                <p>
                  Experience the thrill of riding through rugged terrains and
                  high mountain passes like Khardung La. Our bike tours include
                  well-maintained bikes, backup vehicles, fuel, and expert
                  support.
                </p>
              </div>

              <div className="card">
                <h3>Car Tour Packages</h3>
                <p>
                  Perfect for families and couples, our car tours offer
                  comfortable travel with experienced drivers. Enjoy scenic
                  landscapes without worrying about driving in tough terrains.
                </p>
              </div>

              <div className="card">
                <h3>Premium Tour Packages</h3>
                <p>
                  For those who seek luxury, we offer premium stays, private
                  vehicles, and personalized itineraries to give you the best
                  Ladakh experience.
                </p>
              </div>
            </section>

            <section className="section">
              <h2>Top Places Covered in Ladakh Tour</h2>
              <ul className="list">
                <li>Leh City – Local sightseeing & monasteries</li>
                <li>Nubra Valley – Sand dunes & double-humped camels</li>
                <li>Pangong Lake – Iconic blue lake experience</li>
                <li>Tso Moriri – Peaceful and less crowded destination</li>
                <li>Magnetic Hill & Hall of Fame</li>
                <li>Khardung La & Chang La Pass</li>
              </ul>
            </section>

            <section className="section highlight">
              <h2>Best Time to Visit Ladakh</h2>
              <p>
                The best time to visit Ladakh from Hyderabad is between May to
                September, when roads are open and weather is pleasant. This is
                the ideal time for bike trips, sightseeing, and adventure
                activities.
              </p>
            </section>

            <section className="section">
              <h2>Why Choose Ladakh MotoDrive?</h2>
              <ul className="list tick">
                <li>Local Ladakh-based tour operator</li>
                <li>Affordable and customizable packages</li>
                <li>24/7 on-trip support</li>
                <li>Experienced guides & drivers</li>
                <li>Best accommodations and vehicles</li>
                <li>Trusted by hundreds of travelers</li>
              </ul>
              <p>
                We ensure your Ladakh trip is safe, memorable, and hassle-free.
              </p>
            </section>

            <section className="section cta">
              <h2>Book Your Ladakh Tour Today!</h2>
              <p>
                Ready to explore Ladakh? Let Ladakh MotoDrive plan your dream
                trip from Hyderabad. Whether you want adventure, relaxation, or
                luxury—we have the perfect package for you.
              </p>
            </section>
          </div>
        </>
      ),
    },

    "ladakh-tour-packages-from-bangalore": {
      title: "Ladakh Tour Packages from Bangalore",
      content: (
        <>
          <Helmet>
            <title>
              Ladakh Tour Packages from Bangalore | Ladakh MotoDrive
            </title>

            <meta
              name="description"
              content="Book Ladakh tour packages from Bangalore with Ladakh MotoDrive. Bike, car & premium tours with expert guides. Customize your dream trip today!"
            />

            <link
              rel="canonical"
              href="https://ladakhmotodrive.com/popular/ladakh-tour-packages-from-bangalore"
            />
          </Helmet>
          <div className="popular-container">
            {/* <h1 className="page-title">Ladakh Tour Packages from Bangalore</h1> */}

            <p className="intro">
              Planning a Ladakh trip from Bangalore? Ladakh MotoDrive offers
              expertly designed Ladakh tour packages for adventure lovers,
              families, couples, and groups. Whether you want an exciting bike
              ride through the mountains, a comfortable car tour, or a premium
              luxury experience, we have the perfect package for you.
            </p>

            <section className="section">
              <h2>Travel from Bangalore to Ladakh Made Easy</h2>
              <p>
                Traveling from Bangalore to Ladakh is convenient with multiple
                options available. The fastest way is by flight from Bangalore
                to Leh, while budget travelers can choose train and road
                combinations.
              </p>
              <p>
                Our team ensures a hassle-free experience by managing everything
                from your arrival in Leh to your complete Ladakh itinerary.
              </p>
            </section>

            <section className="section">
              <h2>Our Ladakh Tour Packages from Bangalore</h2>

              <div className="card">
                <h3>Bike Tour Packages</h3>
                <p>
                  Ride through some of the highest motorable roads in the world
                  and experience Ladakh’s rugged beauty. Our bike tours include
                  well-maintained bikes, fuel, backup support, and expert tour
                  captains.
                </p>
              </div>

              <div className="card">
                <h3>Car Tour Packages</h3>
                <p>
                  Perfect for families and couples, our car tours provide
                  comfort, safety, and a relaxed travel experience with
                  experienced drivers.
                </p>
              </div>

              <div className="card">
                <h3>Premium Tour Packages</h3>
                <p>
                  Enjoy a luxurious Ladakh trip with premium hotels, private
                  vehicles, and personalized travel plans.
                </p>
              </div>
            </section>

            <section className="section">
              <h2>Top Places Covered in Ladakh Tour</h2>
              <ul className="list">
                <li>Leh City – Monasteries & local sightseeing</li>
                <li>Nubra Valley – Sand dunes & camel rides</li>
                <li>Pangong Lake – Famous blue lake</li>
                <li>Tso Moriri – Serene and less crowded lake</li>
                <li>Magnetic Hill & Hall of Fame</li>
                <li>Khardung La & Chang La Pass</li>
              </ul>
            </section>

            <section className="section highlight">
              <h2>Best Time to Visit Ladakh</h2>
              <p>
                The best time to visit Ladakh from Bangalore is between May and
                September, when the weather is ideal and roads are open for
                travel.
              </p>
            </section>

            <section className="section">
              <h2>Why Choose Ladakh MotoDrive?</h2>
              <ul className="list tick">
                <li>Local Ladakh-based tour operator</li>
                <li>Affordable and customizable packages</li>
                <li>24/7 on-trip assistance</li>
                <li>Experienced guides & drivers</li>
                <li>Quality accommodations and vehicles</li>
                <li>Trusted by travelers across India</li>
              </ul>
              <p>We ensure your journey is safe, smooth, and memorable.</p>
            </section>

            <section className="section cta">
              <h2>Book Your Ladakh Tour Today!</h2>
              <p>
                Turn your dream Ladakh trip from Bangalore into reality with
                Ladakh MotoDrive. Whether you seek adventure or relaxation, we
                have the perfect package for you.
              </p>
            </section>
          </div>
        </>
      ),
    },

    "ladakh-tour-packages-from-delhi": {
      title: "Ladakh Tour Packages from Delhi",
      content: (
        <>
          <title>Ladakh Tour Packages from Delhi | Ladakh MotoDrive</title>
          <meta
            name="description"
            content="Book Ladakh tour packages from Delhi with Ladakh MotoDrive. Bike, car & premium tours with expert support. Plan your trip today!"
          />
          <link
            rel="canonical"
            href="https://ladakhmotodrive.com/popular/ladakh-tour-packages-from-delhi"
          />
          <div className="popular-container">
            {/* <h1 className="page-title">Ladakh Tour Packages from Delhi</h1> */}

            <p className="intro">
              Planning a Ladakh trip from Delhi? Ladakh MotoDrive offers
              well-designed Ladakh tour packages for adventure seekers,
              families, couples, and groups. Whether you’re looking for an
              exciting bike trip, a comfortable car tour, or a premium luxury
              experience, we provide the perfect travel solution tailored to
              your needs.
            </p>

            <section className="section">
              <h2>Travel from Delhi to Ladakh Made Easy</h2>
              <p>
                Traveling from Delhi to Ladakh is one of the most popular routes
                among travelers. You can either take a direct flight to Leh for
                convenience or enjoy an adventurous road trip via Manali or
                Srinagar.
              </p>
              <p>
                At Ladakh MotoDrive, we help you plan everything from your
                arrival in Leh or your road journey, ensuring a smooth and
                memorable travel experience.
              </p>
            </section>

            <section className="section">
              <h2>Our Ladakh Tour Packages from Delhi</h2>

              <div className="card">
                <h3>Bike Tour Packages</h3>
                <p>
                  Ride through iconic routes like Manali to Leh or Srinagar to
                  Leh. Our bike tours include well-maintained bikes, fuel,
                  backup vehicles, and expert tour captains.
                </p>
              </div>

              <div className="card">
                <h3>Car Tour Packages</h3>
                <p>
                  Perfect for families and groups, our car tours provide a
                  comfortable journey with experienced drivers, allowing you to
                  enjoy Ladakh without any hassle.
                </p>
              </div>

              <div className="card">
                <h3>Premium Tour Packages</h3>
                <p>
                  Experience Ladakh in luxury with premium stays, private
                  vehicles, and personalized itineraries designed for a premium
                  travel experience.
                </p>
              </div>
            </section>

            <section className="section">
              <h2>Top Places Covered in Ladakh Tour</h2>
              <ul className="list">
                <li>Leh City – Local sightseeing & monasteries</li>
                <li>Nubra Valley – Sand dunes & camel rides</li>
                <li>Pangong Lake – Famous blue lake</li>
                <li>Tso Moriri – Peaceful and scenic destination</li>
                <li>Magnetic Hill & Hall of Fame</li>
                <li>Khardung La & Chang La Pass</li>
              </ul>
            </section>

            <section className="section highlight">
              <h2>Best Time to Visit Ladakh</h2>
              <p>
                The best time to visit Ladakh from Delhi is between May and
                September, when weather conditions are favorable and roads are
                accessible.
              </p>
            </section>

            <section className="section">
              <h2>Why Choose Ladakh MotoDrive?</h2>
              <ul className="list tick">
                <li>Trusted local Ladakh tour operator</li>
                <li>Customizable tour packages</li>
                <li>24/7 on-trip support</li>
                <li>Experienced guides and drivers</li>
                <li>Quality hotels and vehicles</li>
                <li>Excellent customer satisfaction</li>
              </ul>
              <p>
                We focus on delivering a safe, smooth, and unforgettable Ladakh
                experience.
              </p>
            </section>

            <section className="section cta">
              <h2>Book Your Ladakh Tour Packages</h2>
              <p>
                Make your dream Ladakh trip from Delhi a reality with Ladakh
                MotoDrive. Whether you want adventure, comfort, or luxury—we
                have the perfect package for you.
              </p>
            </section>
          </div>
        </>
      ),
    },
  };

  const page = pages[slug];

  if (!page) {
    return <h2 className="text-center py-5">Page Not Found</h2>;
  }

  return (
    <>
      <div className="container-fulid">
        <div className="cloud-img">
          <div className="cloud-move">
            <img src={contactImg} alt="cloud" />
          </div>
        </div>

        <div className="page-banner page-banner1">
          <div className="main-title">
            <h3 className="breadcrumb-title">{page.title}</h3>
          </div>
        </div>
      </div>

      <div className="container py-5">
        {/* <h2>{page.title}</h2> */}
        {page.content}
      </div>
    </>
  );
}

export default Popular;
